export const CLINIC = {
  name: "SmileHub",
  doctor: "Dr. M. K. Ovitigala",
  phone: "+94777421620",
  phoneDisplay: "+94 777 421 620",
  email: "mkovitigala@gmail.com",
  fromEmail: "no-reply@smilehub.live",
  mapsUrl: "https://maps.app.goo.gl/fV69n2VRak331RUz9",
  whatsapp: "https://wa.me/94777421620",
};

export const MAIL_API =
  "https://d8ttkphnxe.execute-api.ap-south-1.amazonaws.com/book-appointment";
